import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      viewport={{ once: true }}
      className="bg-darkBlue text-white py-12 mt-10 font-sans shadow-inner"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-heading font-bold">MASA HILLS</h3>
            <p className="text-gray-300 text-sm">
              Compassionate Home Health Services
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/1CSNUwqaJu/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="hover:text-yellow transition-colors duration-300"
              >
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.522-4.478-10-10-10S2 6.478 2 12c0 5 3.657 9.127 8.438 9.877v-6.987h-2.54v-2.89h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.632.771-1.632 1.562v1.875h2.773l-.443 2.89h-2.33v6.987C18.343 21.127 22 17 22 12z" />
                </svg>
              </a>
              <a
                href="tel:+14695730176"
                className="text-gray-300 hover:text-coral transition-colors duration-300"
              >
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                  <path d="M20 15.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.4-5.1-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.3-1.1-.5-2.3-.5-3.5 0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1 0 9.4 7.6 17 17 17 .6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1zM19 12h2c0-4.9-4-8.9-9-9v2c3.9.5 7 3.6 7 7z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <div className="grid grid-cols-2 gap-3 text-sm text-gray-300">
              <Link to="/" className="hover:text-coral transition duration-300">Home</Link>
              <Link to="/services" className="hover:text-teal transition duration-300">Services</Link>
              <Link to="/about" className="hover:text-yellow transition duration-300">About Us</Link>
              <Link to="/jobs" className="hover:text-blue transition duration-300">Jobs</Link>
              <Link to="/contact" className="hover:text-magenta transition duration-300">Contact</Link>
              <Link to="/faqs" className="hover:text-lightOrange transition duration-300">FAQs</Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <div className="text-sm text-gray-300 space-y-1">
              <p>MASA Hills Health Services</p>

              <p>3410 Texas Dr</p>
              <p>Sachse, TX 75048</p>
              <p>Phone: (469) 573-0176</p>
              <p>Email: contact@masahillshealthservices.com</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center">
          <span className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} MASA Hills Health Services. All rights reserved.
          </span>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm text-gray-400">
            <Link to="/privacy-policy" className="hover:text-white transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms-of-services" className="hover:text-white transition-colors duration-300">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
